<template>
    <table class="mdory-data-table">
        <thead>
            <tr>
                <th>{{ title }}</th>
                <th>15 min</th>
                <th>30 min</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in tableData">
                <td v-for="datum in row">{{ datum.toLocaleString() }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>

export default {
  props: ["tableData", "title"],
  mounted () {
  }
}
</script>

<style lang="scss">
    .mdory-data-table {
        border: 0;
        width: 100%;

        caption {
            caption-side: top;
            color: inherit;
            font-weight: bold;
            text-align: center;
        }

        th, td {
            border: 1px solid #ccc;
            border-width: 0 0 1px;
            font-weight: normal;
            padding: .5rem;
            text-align: right;

            &:first-of-type {
                // font-weight: bold;
                padding-left: 0;
                text-align: left;
            }

            &:last-of-type {
                padding-right: 0;
            }
        }

        thead th {
            border-bottom-width: 3px;
            font-weight: bold;
        }

        td:not(:first-of-type) {
            color: #1d91c0;
            font-variant-numeric: tabular-nums;
        }

        tbody > tr:last-child > * {
            border-bottom: 0;
        }
    }

</style>
